import { cn } from "@/lib/utils";
import { TraceDetailsSection } from "../TraceDetails";
import { TraceEvents } from "../TraceEvents";
import type { EnhancedTrace } from "../types";

interface TraceExpandedContentProps {
  trace: EnhancedTrace;
}

export function TraceExpandedContent({ trace }: TraceExpandedContentProps) {
  const hasSpans = trace.spans && trace.spans.length > 0;

  if (hasSpans) {
    console.warn(
      "Multi-span trace detected. This is not really supported yet.",
      trace,
    );
  }

  return (
    <div className="@container flex-1">
      <div
        className={cn("grid gap-4 w-full", {
          "grid-cols-1": !hasSpans,
          "grid-cols-1 @[800px]:grid-cols-2": hasSpans,
        })}
      >
        {/* Transport-specific details section */}
        <TraceDetailsSection trace={trace} />

        {/* Events/Logs section for single span traces */}
        {hasSpans && <TraceEvents span={trace.spans[0]} />}
      </div>
    </div>
  );
}
